import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';

import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class UtilService {

  constructor() {
    moment.locale('pt-BR');
  }

  exibirPdf(pdf: any, nomeArquivo?: string) {
    const navigator: any = window.navigator;

    if (navigator && navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(pdf);
    } else {
      const objectUrl = URL.createObjectURL(pdf);
      const link = document.createElement('a');
      link.download = nomeArquivo || 'Arquivo';
      link.href = objectUrl;
      link.click();
    }
  }

  downloadFileExcel(data: Blob, nomeArquivo: string) {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const blob = new Blob([data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.download = nomeArquivo || 'Planilha';
    link.href = url;
    link.click();
  }

  /**
   * @description Funções para Validações
   *
   */

  verificarDataFimMaiorQueInicio(inicio: any, fim: any): object | null {
    if (this.validarCampoNull(inicio) || this.validarCampoNull(fim)) return null;

    inicio = this.formatarDataPadraoHTML(inicio).replace(/\D/g, '');;
    fim = this.formatarDataPadraoHTML(fim).replace(/\D/g, '');

    if (fim <= inicio) return { dataFimErro: 'A data final não pode ser menor que a data inicial' };

    return null;
  }

  validatorsCustomData(control: AbstractControl): any {
    return this.validarInputData(this.formatarDataPadraoHTML(control.value))
      ? null
      : { dataErro: 'Data inválida' };
  }

  validarInputData(data: any): boolean {
    if (this.validarCampoNull(data)) return true;

    const day = data.substring(8, 10);
    const month = data.substring(5, 7);
    const year = data.substring(0, 4);

    if (month < '01' || month > '12') return false;
    if (day < '01' || day > '31') return false;
    if (year < '1899' || year > '2299') return false;
    if (month == '02' && day > '29') return false;

    if (
      (month == '04' || month == '06' || month == '09' || month == '11') &&
      day > '30'
    ) {
      return false;
    }

    return true;
  }

  validatorsCustomCEP(control: AbstractControl): any {
    return this.validarCEP(control.value)
      ? null
      : { cepErro: 'CEP Inválido' };
  }

  validarCEP(cep: any): boolean {
    if (this.validarCampoNull(cep)) return true;

    const strCEP = this.removerMascaraGenericString(cep);

    if (strCEP.length != 8) return false;

    if (
      strCEP === '00000000' ||
      strCEP === '11111111' ||
      strCEP === '22222222' ||
      strCEP === '33333333' ||
      strCEP === '44444444' ||
      strCEP === '55555555' ||
      strCEP === '66666666' ||
      strCEP === '77777777' ||
      strCEP === '88888888' ||
      strCEP === '99999999'
    ) {
      return false;
    }

    return true;
  }

  validatorsCustomCPF(control: AbstractControl): any {
    return this.validarCpf(control.value)
      ? null
      : { cpfErro: 'CPF Inválido' };
  }

  validarCpf(strCPF: any): boolean {
    if (this.validarCampoNull(strCPF)) return true;

    strCPF = strCPF.toString();
    strCPF = this.removerMascaraCPF(strCPF);

    if (strCPF.length != 11) return false;

    strCPF = strCPF + '';
    let Soma;
    let Resto;
    Soma = 0;

    if (
      strCPF === '00000000000' ||
      strCPF === '11111111111' ||
      strCPF === '22222222222' ||
      strCPF === '33333333333' ||
      strCPF === '44444444444' ||
      strCPF === '55555555555' ||
      strCPF === '66666666666' ||
      strCPF === '77777777777' ||
      strCPF === '88888888888' ||
      strCPF === '99999999999'
    ) {
      return false;
    }

    for (let i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i), 10) * (11 - i);
      Resto = (Soma * 10) % 11;
    }
    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }
    if (Resto !== parseInt(strCPF.substring(9, 10), 10)) {
      return false;
    }
    Soma = 0;

    for (let i = 1; i <= 10; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i), 10) * (12 - i);
      Resto = (Soma * 10) % 11;
    }
    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }
    if (Resto !== parseInt(strCPF.substring(10, 11), 10)) {
      return false;
    }
    return true;
  }

  removerMascaraCPF(input: string): string {
    if (input != null && typeof input === 'string') {
      return input.substring(0, 14).replace(/[^\d\s]/gi, '');
    }
    if (input.length == 10) input += '';
    return input;
  }

  removerMascaraGenericString(str: string | number): string {
    if (this.validarCampoNull(str)) return null;
    const result = str.toString().replace(/[^0-9]+/g, '');
    return result;
  }

  removerMascaraGeneric(str: string | number): number {
    if (this.validarCampoNull(str)) return null;
    const result = str.toString().replace(/[^0-9]+/g, '');
    return parseInt(result);
  }

  validarCampoNull(campo: any): boolean {
    switch (campo) {
      case '':
      case null:
      case 'null':
      case undefined:
        return true;
      default:
        return false;
    }
  }

  /**
   * @description Funções para Formulários
   *
   */
  verificarForm(form: FormGroup): FormGroup {
    for (const c in form.controls) {
      if (form.controls[c]) {
        form.controls[c].markAsTouched();
      }
    }
    return form;
  }

  definirValidatorRequired(control: AbstractControl, condition: boolean): void {
    if (condition) {
      control.setValidators(
        Validators.compose([Validators.required, control.validator])
      );
    }
    control.updateValueAndValidity();
  }

  altenarValidatorRequired(control: AbstractControl, condition: boolean): void {
    if (condition) {
      control.setValidators(
        Validators.compose([Validators.required, control.validator])
      );
    } else {
      control.setErrors(null);
      control.reset();
    }
    control.updateValueAndValidity();
  }

  alternarValidatorRequiredComDesativacao(
    control: AbstractControl,
    condition: boolean
  ): void {
    if (condition) {
      control.setValidators(
        Validators.compose([Validators.required, control.validator])
      );
      control.enable();
    } else {
      control.setErrors(null);
      control.setValue(null);
      control.disable();
    }

    control.updateValueAndValidity();
  }

  /**
   * @description Funções para formatação de Datas
   *
   */
  formatarDataLonga(data: string | Date): string {
    return new Date(data).toLocaleString('pt-BR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
  }

  formatarDataPadraoHTML(data: string): string {
    if (this.validarCampoNull(data)) return null;
    data = data.toString();
    return moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
  }

  formatarDataBR(data: string | Date): string {
    if (this.validarCampoNull(data)) return null;
    data = data.toString();
    return moment(data).format('DDMMYYYY')
  }

  isRequiredField(field: string, form: FormGroup): boolean {
    const form_field = form.get(field);

    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);

    return validator && validator.required;
  }
}
